module.exports = __webpack_public_path__ + "img/board_menu.55536994.png";